import { FC } from 'react';
import FormFiller, { ModalContent, ModalOverlay } from '../../components/FormBuilder/CustomForm/FormFiller';
import { useTheme } from '../../middleware/ThemeContext';

interface GenericFormProps {
  onClose: () => void;
  entityId?: number | null;
  onSuccess?: () => void;
  formType: 'contact' | 'organization';
}

const GenericEntityForm: FC<GenericFormProps> = ({
  onClose,
  entityId,
  onSuccess,
  formType
}) => {
  const { theme } = useTheme();
  return (
    <ModalOverlay>
      <ModalContent theme={theme}>
        <FormFiller onClose={onClose} entityId={entityId} onSuccess={onSuccess} formType={formType} />
      </ModalContent>
    </ModalOverlay>
  );
};

export default GenericEntityForm;